import { getCampaignTitle } from '@esentai/core/features/campaigns/selectors';
import { connect } from 'react-redux';

import Option from '@/components/AutocompleteBase/Option';

const mapStateToProps = (state, { value }) => ({
  label: getCampaignTitle(state, value),
});

export default connect(mapStateToProps, () => ({}))(Option);
